import {
    GET_DRIVER_LIST_PROGRESS, GET_DRIVER_LIST_SUCCESS, GET_DRIVER_LIST_FAILURE,
    ADD_DRIVER_PROGRESS, ADD_DRIVER_SUCCESS, ADD_DRIVER_FAILURE,
    EDIT_DELETE_DRIVER_PROGRESS, EDIT_DELETE_DRIVER_SUCCESS, EDIT_DELETE_DRIVER_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    driver: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const driver_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_DRIVER_LIST_SUCCESS:
            return { ...state, driver: action.driver, loading: false };
        case GET_DRIVER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DRIVER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_DRIVER_PROGRESS:
            return { ...state, loading: true };
        case ADD_DRIVER_SUCCESS:
            return { ...state, driver: [...state.driver, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_DRIVER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_DRIVER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_DRIVER_SUCCESS:
            return {
                ...state,
                driver: state.driver.map((driver) =>
                    driver.id === action.payload.id ? action.payload : driver
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_DRIVER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default driver_reducer;